/**
 * Well known properties
 * - configuration
 * - attributes
 * - values
 *
 * @see https://git.n4group.eu/plansoft/plan-software/3pq/configuration-renderer/configuration-renderer-monorepo/-/issues/264
 */
export var StandardConfigurationTag;
(function (StandardConfigurationTag) {
    /**
     * File link explaining the attribute or value
     */
    StandardConfigurationTag["InfoFile"] = "InfoFile";
    /**
     * Info image on attributes and values
     */
    StandardConfigurationTag["InfoImage"] = "InfoImage";
})(StandardConfigurationTag || (StandardConfigurationTag = {}));
//# sourceMappingURL=StandardConfigurationTag.js.map